// extracted by mini-css-extract-plugin
export default {"wrapper":"FavoriteIcon__wrapper--3VA","actuator":"FavoriteIcon__actuator--QiT","icon":"FavoriteIcon__icon--3xj","featured":"FavoriteIcon__featured--3jF","on":"FavoriteIcon__on--3n-"};